import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=401e32c4&scoped=true&"
import script from "./historyList.vue?vue&type=script&lang=ts&"
export * from "./historyList.vue?vue&type=script&lang=ts&"
import style0 from "./historyList.vue?vue&type=style&index=0&id=401e32c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e32c4",
  null
  
)

export default component.exports